// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yT1CNjb_DHTHO9GBDoBA {
  position: relative;
  width: 100%;
  height: 40rem;
  margin: auto;
  margin-top: 4.5rem;
  overflow: hidden;
  margin-bottom: 3rem;
  padding-top: 1rem;
  background-attachment: fixed;
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.tWWzLIVgUCJnz6xfZlok {
  max-width: 1560px;
  display: flex;
}

.Nt8ZtOvxeMb8cxnJssPO {
  display: flex;
  width: 300%;
  transition: transform 0.5s ease-in-out;
  will-change: transform;
}

.nKIEvLOJMnFOG5pvhn3u {
  flex: 0 0 33.33%;
  box-sizing: border-box;
  padding: 0 10px;
}

.nKIEvLOJMnFOG5pvhn3u img {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  transition: transform 0.3s ease;
}
.nKIEvLOJMnFOG5pvhn3u img:hover {
  transform: scale(1.05);
}

@media screen and (max-width: 1300px) {
  .nKIEvLOJMnFOG5pvhn3u {
    width: 350px;
    height: 350px;
  }
}
@media screen and (max-width: 1000px) {
  .yT1CNjb_DHTHO9GBDoBA {
    height: 20rem;
  }
  .nKIEvLOJMnFOG5pvhn3u {
    width: 250px;
    height: 250px;
  }
}
@media screen and (max-width: 768px) {
  .yT1CNjb_DHTHO9GBDoBA {
    height: 10rem;
    margin-top: 4.5rem;
  }
  .nKIEvLOJMnFOG5pvhn3u {
    flex: 0 0 100%;
    padding: 0 10px;
    width: 100%;
    height: 100%;
  }
  .nKIEvLOJMnFOG5pvhn3u img {
    width: 123px;
    height: 115px;
    margin: 0;
  }
}
@media screen and (max-width: 468px) {
  .yT1CNjb_DHTHO9GBDoBA {
    height: 10rem;
    margin-top: 4.5rem;
  }
  .nKIEvLOJMnFOG5pvhn3u {
    flex: 0 0 100%;
    padding: 0 10px;
    width: 80%;
    height: 80%;
  }
  .nKIEvLOJMnFOG5pvhn3u img {
    width: 92.25px;
    height: 86.25px;
    margin: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/MerchCarousel/MerchCarousel.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,4BAAA;EACA,sBAAA;EACA,2BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,iBAAA;EACA,aAAA;AACF;;AAEA;EACE,aAAA;EACA,WAAA;EACA,sCAAA;EACA,sBAAA;AACF;;AAEA;EACE,gBAAA;EACA,sBAAA;EACA,eAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,+BAAA;AACF;AACE;EACE,sBAAA;AACJ;;AAGA;EACE;IACE,YAAA;IACA,aAAA;EAAF;AACF;AAGA;EACE;IACE,aAAA;EADF;EAIA;IACE,YAAA;IACA,aAAA;EAFF;AACF;AAKA;EACE;IACE,aAAA;IACA,kBAAA;EAHF;EAMA;IACE,cAAA;IACA,eAAA;IACA,WAAA;IACA,YAAA;EAJF;EAOA;IACE,YAAA;IACA,aAAA;IACA,SAAA;EALF;AACF;AAQA;EACE;IACE,aAAA;IACA,kBAAA;EANF;EASA;IACE,cAAA;IACA,eAAA;IACA,UAAA;IACA,WAAA;EAPF;EAUA;IACE,cAAA;IACA,eAAA;IACA,SAAA;EARF;AACF","sourcesContent":[".carouselContainer {\n  position: relative;\n  width: 100%;\n  height: 40rem;\n  margin: auto;\n  margin-top: 4.5rem;\n  overflow: hidden;\n  margin-bottom: 3rem;\n  padding-top: 1rem;\n  background-attachment: fixed;\n  background-size: cover;\n  background-position: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.carousel {\n  max-width: 1560px;\n  display: flex;\n}\n\n.carouselInner {\n  display: flex;\n  width: calc(100% * 3);\n  transition: transform 0.5s ease-in-out;\n  will-change: transform;\n}\n\n.carouselItem {\n  flex: 0 0 33.33%; \n  box-sizing: border-box;\n  padding: 0 10px;\n}\n\n.carouselItem img {\n  width: 100%;\n  height: 100%;\n  border-radius: 8px;\n  transition: transform 0.3s ease;\n\n  &:hover {\n    transform: scale(1.05);\n  }\n}\n\n@media screen and (max-width: 1300px) {\n  .carouselItem {\n    width: 350px;\n    height: 350px;\n  }\n}\n\n@media screen and (max-width: 1000px) {\n  .carouselContainer {\n    height: 20rem;\n  }\n\n  .carouselItem {\n    width: 250px;\n    height: 250px;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .carouselContainer {\n    height: 10rem;\n    margin-top: 4.5rem;\n  }\n\n  .carouselItem {\n    flex: 0 0 100%;\n    padding: 0 10px;\n    width: 100%;\n    height: 100%;\n  }\n\n  .carouselItem img {\n    width: 123px;\n    height: 115px;\n    margin: 0;\n  }\n}\n\n@media screen and (max-width: 468px) {\n  .carouselContainer {\n    height: 10rem;\n    margin-top: 4.5rem;\n  }\n\n  .carouselItem {\n    flex: 0 0 100%;\n    padding: 0 10px;\n    width: 80%;\n    height: 80%;\n  }\n\n  .carouselItem img {\n    width: 92.25px;\n    height: 86.25px;\n    margin: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"carouselContainer": `yT1CNjb_DHTHO9GBDoBA`,
	"carousel": `tWWzLIVgUCJnz6xfZlok`,
	"carouselInner": `Nt8ZtOvxeMb8cxnJssPO`,
	"carouselItem": `nKIEvLOJMnFOG5pvhn3u`
};
export default ___CSS_LOADER_EXPORT___;
